"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** FAB_METABOX_DESIGN */
window.FAB_METABOX_DESIGN = Object.assign(Object.assign({}, window.FAB_METABOX_DESIGN), { 
    /** Linked Option (Padding/Margin) */
    linkedOptions: {
        padding: true,
        margin: true,
    }, 
    /**
     * Define Default Option
     * */
    defaultOptions: Object.assign(Object.assign({}, window.FAB_METABOX_DESIGN.defaultOptions), { select2: { placeholder: '--choose--' } }), 
    /** Init */
    init: () => {
        /** Initiate Select2 */
        jQuery('.fab-container.metabox-design .select2').select2();
        /** Initiate Color Picker */
        jQuery('.fab-container.metabox-design .colorpicker').wpColorPicker();
        /** Initiate Option */
        window.FAB_METABOX_DESIGN.init_option_animation(); // Init option Animation.
        window.FAB_METABOX_DESIGN.init_option_modal_size(); // Init option Modal Size.
        window.FAB_METABOX_DESIGN.init_option_spacing(); // Init option spacing
        window.FAB_METABOX_DESIGN.init_option_layout(); // Init option theme
        window.FAB_METABOX_DESIGN.init_option_theme(); // Init option theme
        window.FAB_METABOX_DESIGN.init_option_template(); // Init option template
        /** Trigger Linked Option */
        jQuery('.fab-linked-option').on('click', window.FAB_METABOX_DESIGN.triggerLinkedOption);
    }, 
    /** Init Animation Option */
    init_option_animation: () => {
        /** Initiate Animation */
        jQuery('.field_option_animation_element').each(function () {
            /** Ignore Animation FAB */
            if (jQuery(this).attr('id') === 'field_option_animation_fab')
                return true;
            /** Set Animation */
            let animationDOM = jQuery(this);
            animationDOM.select2({
                data: window.FAB_PLUGIN.animateCSSAnimation,
            });
            let selected = animationDOM.data('selected');
            if (selected) {
                animationDOM.val(selected);
                animationDOM.trigger('change');
            }
        });
        /** Additional Animation FAB */
        let animationDOM = jQuery('#field_option_animation_fab');
        let data = [...window.FAB_PLUGIN.animateCSSAnimation];
        data.splice(1, 0, { id: 'ripple', text: 'Ripple' });
        animationDOM.select2({ data: data });
        let selected = animationDOM.data('selected');
        if (selected) {
            animationDOM.val(selected);
            animationDOM.trigger('change');
        }
    }, 
    /** Init Template Option */
    init_option_template: () => {
        let dom = jQuery('#field_option_design_template_shape');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_PLUGIN.defaultOptions.template.shape,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
    }, 
    /** Init Modal Size */
    init_option_modal_size: () => {
        let dom = jQuery('#field_option_design_modal_size');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_METABOX_DESIGN.defaultOptions.size.type,
        });
        dom.val(dom.data('selected'));
        dom.on('select2:select', window.FAB_METABOX_DESIGN.triggerDesignSize);
        dom.trigger('change');
        window.FAB_METABOX_DESIGN.triggerDesignSize();
    }, 
    /** Init Option Spacing */
    init_option_spacing: () => {
        /** Sizing Value */
        jQuery('.fab_modal_layout_spacing_sizing').each(function () {
            let dom = jQuery(this);
            let sizing = dom.data('selected');
            if (sizing) {
                dom.val(sizing);
                dom.trigger('change');
            }
        });
        /** Set Initial linkedOptions */
        let spacing = { padding: [], margin: [] };
        jQuery('.fab-modal-layout-spacing').each(function () { spacing[jQuery(this).data('layout')].push(jQuery(this).val()); });
        window.FAB_METABOX_DESIGN.linkedOptions.padding = spacing.padding.every((val, i, arr) => val === arr[0]);
        window.FAB_METABOX_DESIGN.linkedOptions.margin = spacing.margin.every((val, i, arr) => val === arr[0]);
        jQuery('.fab-linked-option').each(function () {
            window.FAB_METABOX_DESIGN.set_linked_spacing_button(this);
        });
        /** Trigger Change */
        jQuery('.fab-modal-layout-spacing').on('keyup', function () {
            let layout = jQuery(this).data('layout');
            if (window.FAB_METABOX_DESIGN.linkedOptions[layout]) {
                jQuery(`.fab-modal-layout-${layout}`).val(jQuery(this).val());
            }
        });
    }, 
    /** Init Option Layout */
    init_option_layout: () => {
        let dom = jQuery('#field_option_design_modal_layout_id');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_METABOX_DESIGN.defaultOptions.layout,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
    }, 
    /** Init Option Theme */
    init_option_theme: () => {
        let dom = jQuery('#field_option_design_modal_theme');
        dom.select2({
            placeholder: '--choose--',
            data: window.FAB_METABOX_DESIGN.defaultOptions.theme,
        });
        dom.val(dom.data('selected'));
        dom.trigger('change');
    }, 
    /** Trigger Design Size */
    triggerDesignSize() {
        let dom_custom_size = jQuery('#setting_design_custom_size');
        let size = jQuery('#field_option_design_modal_size').val();
        if (size === 'custom') {
            dom_custom_size.show();
        }
        else {
            dom_custom_size.hide();
        }
    },
    /** Trigger Linked Option */
    triggerLinkedOption() {
        let layout = jQuery(this).data('layout');
        window.FAB_METABOX_DESIGN.linkedOptions[layout] = !window.FAB_METABOX_DESIGN.linkedOptions[layout];
        window.FAB_METABOX_DESIGN.set_linked_spacing_button(this);
    }, 
    /** Set Button Icon */
    set_linked_spacing_button: (dom) => {
        let layout = jQuery(dom).data('layout');
        let icon = window.FAB_METABOX_DESIGN.linkedOptions[layout] ? 'fa-link' : 'fa-unlink';
        jQuery('em', dom).removeClass('fa-link fa-unlink');
        jQuery('em', dom).addClass(icon);
    } });
